import { render, staticRenderFns } from "./contentLabelCp.vue?vue&type=template&id=7d6feb2c&scoped=true"
import script from "./contentLabelCp.vue?vue&type=script&lang=js"
export * from "./contentLabelCp.vue?vue&type=script&lang=js"
import style0 from "./contentLabelCp.vue?vue&type=style&index=0&id=7d6feb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6feb2c",
  null
  
)

export default component.exports